var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flux-image',{ref:"image",attrs:{"image":_vm.from,"size":_vm.size,"css":_vm.css}})}
var staticRenderFns = []

export { render, staticRenderFns }